<div class="topbar" #topbar [class.is--fixed]="fixed()" [class.is--open]="menuActive()" [class.is--collapsed]="collapsed()">
  <div class="container topbar__inner">
    <a class="topbar__logo" [routerLink]="'/'" (click)="closeOverlay.emit()" title="Foster logo">
      <svg
        class="logo"
        [class.is--collapsed]="collapsed()"
        width="1263"
        height="316"
        viewBox="0 0 1263 316"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        [title]="'Foster logo'"
      >
        <g id="Logo">
          <path
            id="F"
            d="M116.084 113.857H206.905V59.9795H47V255.396H116.084V214.158C116.084 201.134 122.422 195.809 131.728 193.627C140.073 191.689 179.879 191.13 184.226 191.078V144.113L173.594 144.183C129.79 143.799 119.611 185.945 119.611 185.945H116.084V113.857Z"
            fill="white"
          />
          <path
            id="O"
            d="M210.039 157.339C210.039 92.3572 248.623 54.1748 312.383 54.1748C376.142 54.1748 413.923 92.3572 413.923 157.339C413.923 222.321 374.938 260.503 312.383 260.503C249.828 260.503 210.039 221.919 210.039 157.339ZM279.071 157.339C279.071 186.984 287.609 202.418 311.964 202.418C336.319 202.418 345.258 186.984 345.258 157.339C345.258 127.694 336.738 111.44 311.964 111.44C287.19 111.44 279.071 127.676 279.071 157.339Z"
            fill="white"
          />
          <path
            id="S"
            d="M421.958 200.619L483.273 188.031C487.743 206.712 499.51 213.207 515.764 213.207C528.754 213.207 535.248 209.558 535.667 201.021C535.667 193.304 531.198 188.031 498.707 180.716C443.886 167.727 426.008 150.669 426.008 115.734C426.008 75.9283 454.03 54 512.517 54C571.004 54 591.308 76.3298 597.402 109.641L536.488 122.229C533.642 106.795 527.549 99.8992 510.911 99.8992C497.502 99.8992 491.008 103.967 491.008 111.684C491.008 118.999 493.434 125.092 525.925 132.39C589.685 146.602 601.871 168.128 601.871 197.773C601.871 237.579 575.473 260.311 514.141 260.311C444.689 260.311 426.008 233.511 421.958 200.602"
            fill="white"
          />
          <path
            id="T"
            d="M698.861 60.1191H743.137V113.735H698.861V178.717C698.861 190.083 702.929 195.373 716.32 195.373C724.037 195.373 733.779 192.527 739.069 190.903L746.384 252.637C730.549 257.508 721.208 260.354 697.656 260.354C649.33 260.354 629.829 228.684 629.829 191.305V113.735H609.926V60.1191H698.861Z"
            fill="white"
          />
          <path
            id="E"
            d="M754.644 164.013C754.644 95.3824 790.382 55.1748 856.167 55.1748C917.5 55.1748 945.102 90.5114 945.102 143.708C945.102 153.049 945.102 160.364 943.88 170.508H822.454C824.899 197.307 835.042 206.647 855.347 206.647C875.651 206.647 881.343 197.307 884.992 186.744L942.658 202.178C934.121 233.866 913.013 261.468 854.928 261.468C796.842 261.468 754.609 230.601 754.609 163.996M822.454 144.127H882.163C882.967 117.73 873.225 105.945 854.142 105.945C835.06 105.945 824.497 115.687 822.454 144.127Z"
            fill="white"
          />
          <path
            id="R"
            d="M958.223 254.849V60.7244H1023.2V128.953H1028.9C1043.11 66.416 1056.92 58.6992 1079.25 58.6992H1084.12V138.294H1071.13C1034.17 138.294 1027.27 146.011 1027.27 174.434V254.849H958.24H958.223Z"
            fill="white"
          />
          <circle id="dot" cx="1154.81" cy="199.192" r="60.6476" fill="var(--bs-accent, #F8DB69)" />
        </g>
      </svg>
    </a>

    @if (menu().length > 0) {
      <ul class="topbar-nav-list d-none d-xl-flex">
        @for (page of sortedMenu(); track page) {
          @let pageUrl = page.url || '';
          @let trackContext = 'topbar-menu';
          <li class="topbar-nav-list__item" [class.ms-auto]="firstFeaturedItem()?.url === page.url">
            <fstr-link
              [button]="{
                text: page.title,
                url: pageUrl,
                queryParams: page.queryParams || null,
                routerLink: page.routerLink || null,
                fragment: page.fragment || null,
              }"
              [routerLinkActive]="'is--active'"
              [routerLinkActiveOptions]="{ exact: page.url === '/' }"
              [showText]="false"
              class="topbar-link"
              [class.is--featured]="page.featured"
              magnetic
              [trackLinkClick]="pageUrl"
              [trackContext]="trackContext"
            >
              <span>{{ page.title }}</span>
            </fstr-link>
          </li>
        }
      </ul>
    }

    <nav class="topbar__actions d-xl-none">
      <button class="button button-link button--accent" [class.is--active]="menuActive()" (click)="toggleOverlay.emit()" type="button">
        @if (menuActive()) {
          <span>Sluiten</span>
        } @else {
          <span>Menu</span>
        }
        <!--<span class="hamburger" [class.is--active]="menuActive()">
        <span class="hamburger__lines"></span>
      </span>-->
        <span class="knot-toggle" [class.is--active]="menuActive()">
          <span class="knot-toggle__dots"></span>
          <span class="knot-toggle__dots"></span>
        </span>
      </button>
    </nav>
  </div>
</div>

@if (menuActive()) {
  <nav class="nav-overlay" animate.enter="entering" animate.leave="leaving">
    <div class="container nav-overlay__inner custom-scrollbar">
      <span class="text-accent d-block mb-2">Menu</span>
      <ul class="nav-list">
        @for (page of sortedMenu(); track page) {
          @let pageUrl = page.url || '';
          @let trackContext = 'topbar-menu-' + page.title;
          <li
            class="nav-list__item"
            animate.enter="entering"
            animate.leave="leaving"
            [class.mt-auto]="firstFeaturedItem()?.url === page.url"
            [style.--list-index]="$index"
          >
            <fstr-link
              [button]="{
                text: page.title,
                url: pageUrl,
                queryParams: page.queryParams || null,
                routerLink: page.routerLink || null,
                fragment: page.fragment || null,
              }"
              [routerLinkActive]="'is--active'"
              [routerLinkActiveOptions]="{ exact: page.url === '/' }"
              (click)="closeOverlay.emit()"
              [showText]="false"
              class="nav-overlay-link"
              [class.is--featured]="page.featured"
              [class.h2]="!page.featured"
              [class.h6]="page.featured"
              [trackLinkClick]="pageUrl"
              [trackContext]="trackContext"
            >
              <span>{{ page.title }}</span>
            </fstr-link>
          </li>
        }
      </ul>
    </div>
  </nav>
}
